import React, { Fragment, useState } from 'react'
import { Dialog, Disclosure, Popover, Transition } from '@headlessui/react'
import { Link } from 'react-router-dom'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { FaArrowRight } from 'react-icons/fa'

//images (using existing assets)
import brandicon from '../assets/brandlogo.png'
import brandiconmd from '../assets/brandlogomd.png'

const menuItems = [
  { name: 'Home', href: '/', id: 'home' },{
    name: 'Programs', id: 'programs',
  },
//   {
//     name: 'Programs', id: 'programs', children: [
//       { name: 'Bachelors', href: 'https://www.ug.headstart.co.in/' },
//       { name: 'PG Medical', href: 'https://www.pgmedicine.com/' },
//       { name: 'Work in Germany', href: 'https://www.ws.headstart.co.in/' },
//     ]
//   },
  { name: 'Blogs', href: '/blogs', id: 'blogs' },
  { name: 'About Us', href: '/about', id: 'about' }
]

export default function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <nav className="container mx-auto flex items-center justify-between px-6 py-4">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img className="h-10 w-auto lg:hidden" src={brandiconmd} alt="Globalpro" />
          <img className="hidden h-10 w-auto lg:block" src={brandicon} alt="Globalpro" />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex lg:items-center lg:space-x-8">
          {menuItems.map(item => (
            item.children ? (
              <Popover key={item.id} className="relative">
                <Popover.Button className="flex items-center space-x-1 text-gray-700 hover:text-gray-900 font-medium">
                  <span>{item.name}</span>
                  <ChevronDownIcon className="h-4 w-4" />
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute mt-2 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 py-2 w-48">
                    {item.children.map(sub => (
                      <a
                        key={sub.name}
                        href={sub.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
                      >
                        {sub.name}
                      </a>
                    ))}
                  </Popover.Panel>
                </Transition>
              </Popover>
            ) : (
              <Link
                key={item.id}
                to={item.href}
                className="text-gray-700 hover:text-gray-900 font-medium"
              >
                {item.name}
              </Link>
            )
          ))}
        </div>

        {/* CTA & Mobile Toggle */}
        <div className="flex items-center space-x-4">
          <Link
            to="/connect"
            className="hidden lg:inline-flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-indigo-700 transition"
          >
            Connect <FaArrowRight className="ml-2" />
          </Link>
          <button
            onClick={() => setMobileOpen(true)}
            className="lg:hidden p-2 text-gray-700 hover:text-gray-900"
            aria-label="Open menu"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile Menu */}
        <Transition show={mobileOpen} as={Fragment}>
          <Dialog as="div" className="fixed inset-0 z-50" onClose={() => setMobileOpen(false)}>
            <Dialog.Overlay className="fixed inset-0 bg-black/30" />
            <div className="fixed inset-y-0 right-0 w-64 bg-white p-6 space-y-6 overflow-y-auto">
              <div className="flex items-center justify-between">
                <img src={brandicon} alt="Globalpro" className="h-8 w-auto" />
                <button onClick={() => setMobileOpen(false)} className="p-2 text-gray-700 hover:text-gray-900">
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
              <nav className="space-y-4">
                {menuItems.map(item => (
                  <Disclosure key={item.id} as={Fragment}>
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between items-center px-2 py-2 text-gray-700 hover:bg-gray-100 rounded-md">
                          {item.name}
                          {item.children && <ChevronDownIcon className={`h-5 w-5 transform ${open ? 'rotate-180' : ''}`} />}
                        </Disclosure.Button>
                        {item.children && (
                          <Disclosure.Panel className="pl-6 mt-1 space-y-1">
                            {item.children.map(sub => (
                              <a
                                key={sub.name}
                                href={sub.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block text-gray-600 px-2 py-1 rounded hover:bg-gray-100"
                              >
                                {sub.name}
                              </a>
                            ))}
                          </Disclosure.Panel>
                        )}
                      </>
                    )}
                  </Disclosure>
                ))}
              </nav>
              <Link
                to="/connect"
                className="flex items-center justify-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-hover transition"
                onClick={() => setMobileOpen(false)}
              >
                Connect <FaArrowRight className="ml-2" />
              </Link>
            </div>
          </Dialog>
        </Transition>
      </nav>
    </header>
  )
}
